import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import { VNodes } from "../../../../lib/utils/vue/VNodes";
const __script_base__ = {
  name: 'WRadio',
  props: {
    value: {
      required: true
    },
    options: {
      type: Array,
      required: false
    },
    readonly: {
      type: Boolean,
      required: false
    },
    required: {
      type: Boolean,
      required: false
    },
    withSolidFill: {
      type: Boolean,
      required: false
    },
    // 下面是 dataSchema 的
    className: {
      type: String,
      default: ''
    },
    schema: {
      type: Object,
      required: false
    } // 如果 options 为空，可从这里取
  },
  model: {
    prop: 'value',
    event: 'change' // 和 dataSchema 的保持了一致
  },
  components: {
    VNodes
  },
  computed: {
    safeExtraClassName() {
      return mergeClassName(this.withSolidFill && 'withSolidFill', this.readonly && 'isReadonly', this.className);
    },
    safeOptions() {
      var _this$schema;
      return this.options || ((_this$schema = this.schema) === null || _this$schema === void 0 ? void 0 : _this$schema.enum) || [];
    }
  },
  methods: {
    validate() {
      if (this.readonly) return; // 只读模式不需要校验

      const {
        value
      } = this;
      if (!value && this.required) throw new Error('此字段必填');
      // 话说，要不要校验选项是否存在于 enum
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "w-radio",
    class: _vm.safeExtraClassName
  }, [_vm._l(_vm.safeOptions, function (it, i) {
    return _c('button', {
      key: i,
      staticClass: "w-radio-item",
      class: {
        isActive: _vm.value === it.value
      },
      attrs: {
        "type": "button",
        "disabled": _vm.readonly
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('change', it.value);
        }
      }
    }, [_c('VNodes', {
      attrs: {
        "vnodes": it.label || String(it.value)
      }
    })], 1);
  }), _vm._v(" "), !_vm.safeOptions.length ? _c('button', {
    staticClass: "w-radio-item",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")]) : _vm._e()], 2);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Radio/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);